
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Equipes from "../pages/equipes/page";
import Bureau from "../pages/bureau/page";
import Contact from "../pages/contact/page";
import GaleriePage from '../pages/galerie/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/equipes',
    element: <Equipes />
  },
  {
    path: '/galerie',
    element: <GaleriePage />
  },
  {
    path: '/bureau',
    element: <Bureau />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;